export default __webpack_public_path__ + "static/media/red_circle.e25d7f9a.svg";